import { ObjectMode } from '@databases/types';
import { Database, DatabaseFieldType } from '@databases/types/database';
import {
  createField,
  generateValuesForEntriesById,
  getNewDatabase,
} from '@databases/utils/database/utils';

export const databaseForCopyAndPasteWithUserFieldContentId = '841041';

export const databaseForCopyAndPasteWithUserField = (): Database<ObjectMode.EXISTING> => {
  const baseDatabase = getNewDatabase();

  const fields = [
    ...Array.from({ length: 3 }, (_, index) => ({
      ...createField(DatabaseFieldType.TEXT),
      name: `Text Field ${index}`,
    })),
    {
      ...createField(DatabaseFieldType.USER),
      name: `User Field`,
    },
  ];

  const entriesById = generateValuesForEntriesById(baseDatabase.entries, fields);

  return {
    ...baseDatabase,
    fields: fields.map((field) => field.id),
    fieldsById: Object.fromEntries(fields.map((field) => [field.id, field])),
    contentId: databaseForCopyAndPasteWithUserFieldContentId,
    entriesById,
    entries: Object.keys(entriesById),
    meta: {
      ...baseDatabase.meta,
      isLocked: false,
    },
    space: { key: 'TEST', name: 'Test', id: 1234 },
    operations: {
      delete: false,
      updateEntries: true,
      updateMetadata: true,
    },
  } as Database<ObjectMode.EXISTING>;
};
